module.exports = __webpack_public_path__ + "img/3-4_Data_Upload.0969d137.png";